import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { VoucherRepository } from '@app/domain/ports/tpv/voucher.repository';
import { SendVoucherRequest, VoucherMode } from '@app/data/dtos/tpv/voucher.dto';

/** Mock de comprobantes para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class VoucherMockDataSource extends VoucherRepository {
  override getVoucherUrl(_idTransaction: string, _mode: VoucherMode): Observable<string> {
    return of('https://mock/voucher.pdf').pipe(delay(300));
  }

  override sendVoucher(_idTransaction: string, _request: SendVoucherRequest): Observable<void> {
    return of(void 0).pipe(delay(300));
  }
}
